import PropTypes from 'prop-types';

import CheckboxWithInfoTooltip from 'common/components/CheckboxWithInfoTooltip';

export const ALERT_PARTNER_CHECKBOX = {
  label: 'Notify partner via Email',
  helperText:
    "Email this catalog change to this partner's configured recipients if its catalog email notifications are enabled.",
};

export const ALERT_PARTNERS_CHECKBOX = {
  label: 'Notify partners via Email',
  helperText:
    "Email this catalog change to each affected partner's configured recipients if their catalog email notifications are enabled.",
};

const AlertPartnersCheckbox = ({ id, text, checked, onChange, sx }) => (
  <CheckboxWithInfoTooltip
    id={id}
    label={text.label}
    helperText={text.helperText}
    checked={checked}
    onChange={onChange}
    sx={sx}
  />
);

AlertPartnersCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  text: PropTypes.shape({
    label: PropTypes.string.isRequired,
    helperText: PropTypes.string.isRequired,
  }).isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  sx: PropTypes.shape({}),
};

AlertPartnersCheckbox.defaultProps = {
  sx: {},
};

export default AlertPartnersCheckbox;
